module.exports = __webpack_public_path__ + "assets/img/title-download-note-be64ebf4.png";